import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col, Table } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useLoader } from "../../_helper/LoaderContext";
import { usePharmacy } from "../../_helper/PharmacyProvider";
import { viewAdjustment } from "./InventoryService";
import { FaArrowLeft } from "react-icons/fa6";

const ViewInventory = () => {
  const [products, setProducts] = useState([]);
  const [adjustmentDetails, setAdjustmentDetails] = useState({});
  const { t } = useTranslation();
  const { invId } = useParams();
  const { setLoading } = useLoader();
  const { pharmacyPOS } = usePharmacy();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStock = async () => {
      const body = {
        clinicId: pharmacyPOS?.hospital_id,
        inventoryId: invId,
      };
      try {
        setLoading(true);
        const response = await viewAdjustment(body);
        if (response.data?.status === "success") {
          const data = response.data.data;
          setAdjustmentDetails(data);
          setProducts(data.inventoryItems || []);
        }
      } catch (error) {
        console.error("Error fetching stock details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStock();
  }, [invId]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString(undefined, { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`; // Example: May 07, 2025
  };

  return (
    <Fragment>
      <Breadcrumbs
        mainTitle={t("View Adjustment")}
        parent={t("Dashboard")}
        title={t("View Adjustment")}
      />

      <Col sm="12">
        <Card>
          <CardBody>
            {/* Adjustment Details */}
            <h5 className="mb-3">{t("Adjustment Details")}</h5>
            <div className="d-flex justify-content-end tw-w-full tw-mb-2">
              <button className="btn btn-primary" onClick={() => navigate(-1)}>
                <FaArrowLeft className="me-2" /> {t("Back")}
              </button>
            </div>
            <div className="mb-4 rounded table-responsive">
              <Table className="mb-0 table-center table-bordered table-hover">
                <thead>
                  <tr>
                    <th>{t("Adjustment Number")}</th>
                    <th>{t("Adjustment Type")}</th>
                    <th>{t("Date")}</th>
                    <th>{t("Reason")}</th>
                    {/* <th>{t("Note")}</th> */}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{adjustmentDetails.inventoryNumber}</td>
                    <td>
                      <span
                        className={`badge ${
                          adjustmentDetails.adjustmentType === "add"
                            ? "bg-success"
                            : "bg-danger"
                        }`}
                      >
                        {adjustmentDetails.adjustmentType === "add"
                          ? t("Add")
                          : t("Deduct")}
                      </span>
                    </td>
                    <td>{formatDate(adjustmentDetails.adjustmentDate)}</td>
                    <td>{adjustmentDetails.adjustmentReason}</td>
                    {/* <td>{adjustmentDetails.note}</td> */}
                  </tr>
                </tbody>
              </Table>
            </div>

            {/* Adjusted Products */}
            <h5 className="mb-3">{t("Adjusted Products")}</h5>
            <div className="rounded table-responsive">
              <Table className="mb-0 table-center table-bordered table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{t("Code")}</th>
                    <th>{t("Product Name")}</th>
                    <th>{t("Medicine Name")}</th>
                    <th>{t("Batch Number")}</th>
                    <th>{t("Package")}</th>
                    <th>{t("Quantity")}</th>
                    {/* <th>{t("Adjustment Type")}</th> */}
                  </tr>
                </thead>
                <tbody>
                  {products.map((item, index) => (
                    <tr key={item.itemId}>
                      <td>{index + 1}</td>
                      <td>{item.code}</td>
                      <td>{item.brandName}</td>
                      <td>{item.medicineName}</td>
                      <td>{item.batchNumber}</td>
                      <td>{item.package}</td>
                      {/* <td>{item.quantity}</td> */}
                      <td>
                        <span
                          className={`${
                            item.adjustmentType === "add"
                              ? "text-success"
                              : "text-danger"
                          }`}
                        >
                          {item.adjustmentType === "add" ? "+" : "-"}{" "}
                          {item.quantity}
                        </span>
                      </td>
                    </tr>
                  ))}
                  {products.length === 0 && (
                    <tr>
                      <td colSpan="8" className="text-center">
                        {t("No products found")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default ViewInventory;
